const isBlank = (value) => value === undefined || value === null || String(value).trim() === "";
const isEnabled = (value) => value === true || value === "true";

export const validateVariant = (variant) => {
  if (isBlank(variant.name)) return "Name cannot be empty";
  if (isBlank(variant.rate) || Number(variant.rate) === 0) return "Rate cannot be empty";
  const foodType = isBlank(variant.food_type) ? variant.type : variant.food_type;
  if (isBlank(foodType)) return "Food type cannot be empty";
  if (isEnabled(variant.offer_enabled) && isBlank(variant.offer_rate)) {
    return "Offer price is required when the offer is enabled";
  }
  if (isEnabled(variant.offer_enabled) && Number(variant.offer_rate) <= 0) {
    return "Offer price must be above 0 when the offer is enabled";
  }
  if (!isBlank(variant.offer_rate) && Number(variant.offer_rate) >= Number(variant.rate)) {
    return "Offer price must be less than retail price";
  }
  if (!isBlank(variant.order_limit) && !/^\d+$/.test(String(variant.order_limit).trim())) {
    return "Order limit must be a whole number, or blank for no limit";
  }
  return null;
};

export const validateOfferToggle = (variant, turningOn) => {
  if (!turningOn) return null;
  const rate = variant ? variant.offer_rate : null;
  if (isBlank(rate) || Number(rate) <= 0) {
    return "Set an offer price above 0 before enabling the offer";
  }
  return null;
};
